module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue7.7d755f9f.jpg";